import {Editor, mergeAttributes} from "@tiptap/core";
import {AiGeneratorNode} from "./ai-generator";

export class AiGeneratorView {

    private _dom: HTMLElement;
    private _domContent: HTMLDivElement;
    private _editor: Editor;
    private _attrs: Record<string, any>;
    private _getPos: any;
    private editorWidth: number;

    constructor(editor: Editor, attrs: Record<string, any>, getPos: any) {
        this._editor = editor;
        this._attrs = attrs;
        this._getPos = getPos;

        console.log("AAAAAA", attrs);

        this._dom = document.createElement('div');
        this._dom.setAttribute("data-prompt", attrs['data-prompt'])

        this._dom.style.border = "1px solid #444";

        this.createContent();

        let input = document.createElement('textarea');
        this._dom.append(input);

        input.value = attrs['data-prompt'];

        let btn = document.createElement('button');
        btn.innerHTML = "Generuj"
        this._dom.append(btn);

        let btnApply = document.createElement('button');
        btnApply.innerHTML = "Wstaw"
        this._dom.append(btnApply);

        btn.addEventListener('click', e=> {
            // let element = document.createElement("p");
            // element.innerHTML = input.value + "<b>bold</b> tekst po bold";
            // this._domContent.append(element);

            if(typeof this._getPos === 'function') {
                console.log(this._getPos());

                // this._editor.chain()
                //     .setNodeSelection(this._getPos())
                //     .insertContentAt(this._getPos(), [
                //         {
                //             type: 'paragraph',
                //             content: [
                //                 {
                //                     type: 'text',
                //                     text: input.value
                //                 }
                //             ]
                //         }
                //     ])
                //     .focus()
                //     .run();

                this._editor.view.dispatch(
                    this._editor.view.state.tr.setNodeAttribute(this._getPos(), "prompt", input.value)
                );

                input.focus();

                console.log("DISPATCH!!!!");

                //this._editor.commands.focus();
            }

        });

        btnApply.addEventListener('click', e => {
            this._editor.chain()
                .setNodeSelection(this._getPos())
                .toggleWrap('ai-block')
                .run();
        })

        // this._dom.append(
        //     this.createTextarea()
        // );

        //this.createContent();
    }


    private createContent(){
        this._domContent = document.createElement('div');
        this._domContent.classList.add("content");
        //this._domContent.classList.add("is-editable");
        this._domContent.style.border = "2px solid #4fa";
        this._domContent.style.minHeight = "30px";

        let p = document.createElement('p');
        p.innerHTML = "ala ma kota";

        this._domContent.append(p);

        this._dom.append(this._domContent);
    }

    private createTextarea(): HTMLDivElement{

        let div = document.createElement("div");
        div.setAttribute("contenteditable", "false");
        div.contentEditable = "false";

        let textarea = document.createElement("input");
        textarea.style.width = "100%";

        let btn = document.createElement("button");
        btn.innerHTML = "Generuj";

        div.style.padding = "5px";
        div.style.border = "1px solid #eee";

        div.append(textarea);
        div.append(btn);

        btn.addEventListener('click', e=> {

        })

        return div;
    }


    get dom(): any {
        return this._dom;
    }

    get domContent(): HTMLDivElement {
        return this._domContent;
    }

    deselectNode(): void {
        this._dom.classList.remove("SelectedNode")
    }

    selectNode(): void {
        this._dom.classList.add("SelectedNode")
    }
}
